import ActivitiesListing from './ActivitiesListing';

export default ActivitiesListing;
